import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { pagesService } from '../services/pages';
import type { UpdatePageInput, UpdateSectionInput } from '../types/entities';
import { toast } from 'sonner';
import { apiClient } from '../services/api';

export function usePages() {
  return useQuery({
    queryKey: ['pages'],
    queryFn: () => pagesService.getAll(),
  });
}

export function usePageById(id: string) {
  return useQuery({
    queryKey: ['pages', id],
    queryFn: () => pagesService.getById(id),
    enabled: !!id,
  });
}

export function useUpdatePage() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdatePageInput }) =>
      pagesService.updatePage(id, data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['pages'] });
      queryClient.invalidateQueries({ queryKey: ['pages', variables.id] });
      toast.success('Page mise à jour');
    },
    onError: (error) => {
      toast.error(apiClient.getErrorMessage(error));
    },
  });
}

export function useUpdateSection() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateSectionInput }) =>
      pagesService.updateSection(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['pages'] });
      toast.success('Section mise à jour');
    },
    onError: (error) => {
      toast.error(apiClient.getErrorMessage(error));
    },
  });
}
